import React, { useState } from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Checkbox,
    FormControl,
    InputLabel,
    Select,
    ListItemText,
    Input
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { adminGetAccountTypeList } from '../../redux/actions/adminGetAccountTypeListAction';
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import "../../components/LoadingSpinner/spinner.css";
import success from "../../assets/img/success.png";
import BackButton from "../../components/BackButton/BackButton";
import failed from "../../assets/img/failed.png";
import { useEffect } from 'react';
import { adminCountryMappingListAction } from '../../redux/actions/adminCountryMappingListAction';
import { adminGetCountryList } from '../../redux/actions/adminGetCountryList';
import { adminCountryMappingAction } from '../../redux/actions/adminCountryMappingAction';
import { Delete } from '@mui/icons-material';
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { adminDeleteCountryMapping } from '../../redux/actions/adminDeleteCountryMappingAction';
import { countryMappingCompareListAdmin } from '../../redux/actions/adminCountryMappingCompareListAction'
import val from "../../getThemeDetails";
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AdminMappingCountry = () => {

    const classes = useStyles();
    const [countries, setcountries] = useState([]);
    const [walletOwnerID, setwalletOwnerID] = useState('');
    const [searchWalletOwnerID, setsearchWalletOwnerID] = useState('');
    const [countryList, setcountryList] = useState([]);
    const [createSet, setcreateSet] = useState(false);
    const [mappingRespDescription, setmappingRespDescription] = useState('');
    const [notificationOpen, setnotificationOpen] = useState(false);
    const [searchSet, setsearchSet] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [countryMappingArr, setcountryMappingArr] = useState([]);
    const [page, setPage] = useState(0);
    const [bankType, setbankType] = useState('');
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [deleteSet, setdeleteSet] = useState(false);
    const [deleteDescription, setdeleteDescription] = useState('');
    const [openDeleteNotification, setopenDeleteNotification] = useState(false);
    const [bankTypeList, setbankTypeList] = useState([]);
    const [bankTypeSet, setbankTypeSet] = useState(false);
    const [walletOwnerIdResp, setwalletOwnerIdResp] = useState([]);

    const getCountryListRes = useSelector(({ getCountryList }) => getCountryList);
    const getWalletOwnerIdRes = useSelector(({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList);
    const admincountrymappinglistres = useSelector(({ admincountrymappinglist }) => admincountrymappinglist);
    const adminGetAccountTypeListRes = useSelector(({ adminGetAccountTypeList }) => adminGetAccountTypeList);
    const countryMappingRes = useSelector(({ admincountrymapping }) => admincountrymapping);
    const adminDeleteCountryMappingRes = useSelector(({ adminDeleteCountryMapping }) => adminDeleteCountryMapping);

    const countryMappingCompareListRes = useSelector(({ adminCountryMappingComparesLists }) => adminCountryMappingComparesLists)
    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    var authToken = regenerateTokenRes.data.AuthToken;

    const chagneSearchWalletOwnerId = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'searchWalletOwnerID') {
            setsearchWalletOwnerID(value);
        }
    }

    const submitsearchfunc = () => {
        setisLoading(true);
        setsearchSet(true);
        const req = {
            actionCustomerMasterRequestVO: {

                walletOwnerId: searchWalletOwnerID === 'Select Owner Id' ? '' : searchWalletOwnerID,
            }
        }
        dispatch(adminCountryMappingListAction(req, authToken));
        setPage(0)
    }

    const adminCountryMappingListCompareReq = (walletOwnerID) => {
        console.log("logggg");
        const req = {
            actionCustomerMasterRequestVO: {

                walletOwnerId: walletOwnerID.split('-')[0],
            },
        };
        dispatch(countryMappingCompareListAdmin(req, authToken));
        setPage(0);
    };

    useEffect(() => {
        submitsearchfunc()
    }, []);

    const [countrySet, setcountrySet] = useState(false);

    const getCurrencyMasterListReq = () => {
        setcountrySet(true);
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: walletOwnerID.split("-")[0],
                country: "",
                countryCode: "",
                countryIso: ""
            }
        }
        dispatch(adminGetCountryList(req, authToken));
    };

    const getCountryResp = () => {
        if (countrySet) {
            if (getCountryListRes.data.status === 'success') {
                console.log("COUNTRYN MAPPING",
                    getCountryListRes)
                setcountryList
                    (getCountryListRes.data.customerMasterDetailsRequestVOList);
                console.log(
                    "valuesss",
                    walletOwnerID,
                    bankType.split("-")[1],
                    countryMappingCompareListRes.data.customerMasterDetailsRequestVOList,
                    getCountryListRes.data.customerMasterDetailsRequestVOList
                );
                if (bankType && countryMappingCompareListRes.data.description != "list not retrieved" && getCountryListRes.data.customerMasterDetailsRequestVOList && countryMappingCompareListRes.data.customerMasterDetailsRequestVOList) {
                    manageCountries(
                        walletOwnerID,
                        bankType.split("-")[1],
                        [].concat(countryMappingCompareListRes.data.customerMasterDetailsRequestVOList),
                        [].concat(
                            getCountryListRes.data.customerMasterDetailsRequestVOList
                        )
                    );
                }
            }

            if (getCountryListRes.data.status === 'failed') {
                if (
                    getCountryListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getCountryListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    const [user, setUser] = useState({
        walletOwnerID: "",
        currency: "",
        country: "",
        isDefault: ""
    });

    useEffect(() => {
        setCountryMappingFunc();
    }, [admincountrymappinglistres.data.status]);

    useEffect(() => {
        getCountryResp();
    }, [getCountryListRes.data.status]);

    const setCountryMappingFunc = () => {
        if (searchSet) {
            if (admincountrymappinglistres.data.status === 'success') {
                setcountryMappingArr(admincountrymappinglistres.data.customerMasterDetailsRequestVOList);
                setisLoading(false);
            }
            if (admincountrymappinglistres.data.status === 'failed') {
                setcountryMappingArr([]);
                setisLoading(false);
                if (
                    admincountrymappinglistres.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    admincountrymappinglistres.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    const setDeleteRespFunc = () => {
        if (deleteSet) {
            if (adminDeleteCountryMappingRes.data.status === 'success') {
                setdeleteDescription(adminDeleteCountryMappingRes.data.description);
                setopenDeleteNotification(true);
                submitsearchfunc();
                setdeleteSet(false);
                setcountries('')
                setwalletOwnerID('')
                setbankType('')
            }
            if (adminDeleteCountryMappingRes.data.status === 'failed') {
                setdeleteDescription(adminDeleteCountryMappingRes.data.description);
                setopenDeleteNotification(true)
                setdeleteSet(false);
                if (
                    adminDeleteCountryMappingRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    adminDeleteCountryMappingRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        setDeleteRespFunc();
    }, [adminDeleteCountryMappingRes.data.status])

    const getCountryMappingResp = () => {
        if (createSet) {
            if (countryMappingRes.data.status === 'success') {
                setmappingRespDescription(countryMappingRes.data.description)
                setnotificationOpen(true);
                submitsearchfunc();
            }
            if (countryMappingRes.data.status === 'failed') {
                setmappingRespDescription(countryMappingRes.data.description)
                setnotificationOpen(true)
                if (
                    countryMappingRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    countryMappingRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    const handleNoticationClose = () => {
        setnotificationOpen(false);
        setmappingRespDescription('');
    }

    const deleteNotificationClose = () => {
        setdeleteDescription('')
        setopenDeleteNotification(false)
    }

    useEffect(() => {
        getCountryMappingResp();
    }, [countryMappingRes.data.status]);

    const dispatch = useDispatch();

    const getWalletOwnerIdFunc = () => {
        dispatch(
            getWalletOwnerIdAndNameList(
                {
                    loginDetails: {
                        // adminId: regenerateTokenRes.data.partnerId
                        adminId: val.adminIDS
                    }
                },
                authToken
            )
        )
    }

    useEffect(() => {
        getWalletOwnerIdFunc();
    }, [authToken])

    useEffect(() => {
        if (getWalletOwnerIdRes.data.status === 'success') {
            setwalletOwnerIdResp(getWalletOwnerIdRes.data.ownerList);
        }
        if (getWalletOwnerIdRes.data.status === 'failed') {
            if (
                getWalletOwnerIdRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getWalletOwnerIdRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }, [getWalletOwnerIdRes.data.status])

    const onInputChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    const createCurrencyMappingReq = () => {
        const getIds = (ma, ar) => {
            let fa = [];
            let maKey = ma.map(x => x.countryName);
            for (let i = 0; i < ar.length; i++) {
                fa.push(ma[maKey.indexOf(ar[i])].id)
            }
            return fa;
        }
        let req = {
            actionCustomerMasterRequestVO: {
                countryCodeId: getIds(countryList, countries).length == 0 ? '' : getIds(countryList, countries),
                walletOwnerId: walletOwnerID.split('-')[0],
                bankType: bankType.split('-')[1]
            }
        }
        dispatch(adminCountryMappingAction(req, authToken));
        setcreateSet(true);
        setcountries([]);
        setwalletOwnerID('');
        setbankType('');
    };

    const handleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'countries') {
            if (value.includes('all')) {
                setcountries(
                    countries.length ===
                        countryList.filter(ch => !ch.disabled).length
                        ? [] :
                        countryList.filter(ch => !ch.disabled).map(x => x.countryName)
                )
            } else {
                setcountries(value);
            }
        }
        if (name === 'walletOwnerID') {
            // getCurrencyMasterListReq()
            setbankType('');
            setwalletOwnerID(value);
            getBankTypeList();
        }
        if (name === 'bankType') {
            setbankType(value);
            // manageCountries(walletOwnerID.split('-')[0], value.split('-')[1], countryMappingArr, countryList);
        }
    }

    const manageCountries = (wid, btype, mar, cclist) => {
        console.log("inside final", wid, btype, mar, cclist);

        // const mapped = [].concat(mar).filter(ch => ch.walletOwnerId === wid && ch.bankType === btype).map(x => x.countryName);
        // for (let i = 0; i < cclist.length; i++) {
        //     cclist[i].disabled = false;

        //     for (let j = 0; j < mapped.length; j++) {
        //         if (cclist[i].countryName == mapped[j]) {
        //             cclist[i].disabled = true;
        //             break;
        //         }
        //     }
        // }
        for (let i = 0; i < cclist.length; i++) {
            let checkId = cclist[i].countryName;
            console.log("checkId", checkId);
            console.log("mainArrr", mar);
            for (let j = 0; j < mar.length; j++) {
                console.log("mainEl", mar[j]);

                if (checkId == mar[j].countryName && mar[j].bankType == btype) {
                    cclist[i].disabled = true;
                    console.log("toneEl", cclist[i]);
                }
            }
        }
        setcountryList(cclist);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const deleteModal = id => {
        setdeleteSet(true);
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                mappingId: id
            }
        }
        dispatch(adminDeleteCountryMapping(req, authToken))
    }

    // useEffect(() => {
    //     getBankTypeList()
    // }, [])

    const getBankTypeList = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                id: "",
                accountName: ""
            }
        }
        dispatch(adminGetAccountTypeList(req, authToken));
        setbankTypeSet(true);
    }

    const setDropdownAccountType = () => {
        if (bankTypeSet) {
            if (adminGetAccountTypeListRes.data.status === 'success') {
                setbankTypeList(adminGetAccountTypeListRes.data.customerMasterDetailsRequestVOList);
                submitsearchfunc();
                setisLoading(false);
            }
            if (adminGetAccountTypeListRes.data.status === 'failed') {
                if (
                    adminGetAccountTypeListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    adminGetAccountTypeListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        setDropdownAccountType();
    }, [adminGetAccountTypeListRes.data.status])

    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <DialogTitle>Create Mapping Country</DialogTitle>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                variant='standard'
                                label="Owner ID"
                                fullWidth={true}
                                name="walletOwnerID"
                                value={walletOwnerID || "Select Owner Id"}
                                // onChange={handleChange}
                                onChange={(e) => {
                                    console.log("compare req", e.target.value)

                                    handleChange(e);
                                    adminCountryMappingListCompareReq(e.target.value);
                                }}
                            >
                                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                                    Select Owner Id
                                </MenuItem>
                                {walletOwnerIdResp &&
                                    [].concat(walletOwnerIdResp).map((x) => (
                                        <MenuItem key={x.split("-")[0]} value={x}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Select Bank Type"
                                variant='standard'

                                fullWidth={true}
                                name="bankType"
                                value={bankType || ""}
                                // onChange={handleChange}
                                // adminCountryMappingListCompareReq
                                onChange={(e) => {
                                    handleChange(e);
                                    getCurrencyMasterListReq
                                        (
                                            e.target.value.split("-")[0],
                                            e.target.value.split("-")[1]
                                        );
                                }}
                            >
                                <MenuItem value="" selected="Select Bank Type">
                                    Select Bank Type
                                </MenuItem>
                                {bankTypeList &&
                                    [].concat(bankTypeList).map((x, index) => (
                                        <MenuItem key={index} value={`${x.id}-${x.accountName}`}>{x.accountName}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <FormControl className={classes.formControl} style={{ width: '100%', marginTop: '-4px' }}>
                                <InputLabel id='multipleCountrySelect'>Select Countries</InputLabel>
                                <Select
                                    labelId='multipleCountrySelect'
                                    multiple
                                    fullWidth={true}
                                    variant='standard'

                                    value={countries || []}
                                    input={<Input />}
                                    renderValue={selected => selected.join(', ')}
                                    onChange={handleChange}
                                    name='countries'
                                >
                                    <MenuItem key='all' value='all'>
                                        <Checkbox color='primary'
                                            checked={countries.length ===
                                                countryList.filter(ch => !ch.disabled).length} />
                                        <ListItemText primary='Select All' />
                                    </MenuItem>
                                    {
                                        countryList &&
                                        [].concat(countryList).map((x, index) => {
                                            return (
                                                <MenuItem key={index}
                                                    disabled={x.disabled}
                                                    value={`${x.countryName}`}>
                                                    <Checkbox color='primary'
                                                        checked={countries.indexOf(`${x.countryName}`) > -1} />
                                                    <ListItemText primary={x.countryName} />
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={createCurrencyMappingReq}
                            >
                                Create
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>
                <Card>
                    <DialogTitle>Search</DialogTitle>
                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                variant='standard'
                                label="Owner ID"
                                fullWidth={true}
                                name="searchWalletOwnerID"
                                value={searchWalletOwnerID || "Select Owner Id"}
                                onChange={chagneSearchWalletOwnerId}
                            >
                                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                                    Select Owner Id
                                </MenuItem>
                                {walletOwnerIdResp &&
                                    [].concat(walletOwnerIdResp).map((x) => (
                                        <MenuItem key={x.split("-")[0]} value={x.split("-")[0]}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={submitsearchfunc}
                            >
                                Search
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {
                    isLoading ? (<LoadingSpinner />) : countryMappingArr.length == 0 || countryMappingArr == undefined || countryMappingArr == [] || !countryMappingArr ? (
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                        className="themeText"

                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Alert
                                        className="my-3 tableHeaderColor"
                                        variant="secondary"
                                        style={{ color: "white" }}
                                    >
                                        No Records Found!
                                    </Alert>
                                </Grid>
                            </Grid>
                        </Card>
                    ) : (
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                        className="themeText"

                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="my-3">
                                    <Table
                                        className={classes.table}
                                        size="small"
                                        aria-label="a dense table"
                                    >
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Mapping ID
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Bank Type
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Country
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Owner Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {countryMappingArr &&
                                                []
                                                    .concat(countryMappingArr)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center"> {row.mappingId === '' ? '-' : row.mappingId} </TableCell>
                                                            <TableCell align="center"> {row.bankType === '' ? '-' : row.bankType} </TableCell>
                                                            <TableCell align="center"> {row.countryName === '-' ? '' : row.countryName} </TableCell>
                                                            <TableCell align="center">{row.ownerName === '' ? '-' : row.ownerName}</TableCell>
                                                            <TableCell align="center">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() => deleteModal(row.mappingId)}
                                                                >
                                                                    <Delete style={{ color: "#fff" }} />
                                                                </CustomButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(countryMappingArr).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    )
                }

            </Layout>

            {countryMappingRes.data.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {mappingRespDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {countryMappingRes.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {mappingRespDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {adminDeleteCountryMappingRes.data.status == "success" && (
                <div>
                    <Dialog open={openDeleteNotification} onClose={deleteNotificationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={deleteNotificationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {adminDeleteCountryMappingRes.data.status == "failed" && (
                <div>
                    <Dialog open={openDeleteNotification} onClose={deleteNotificationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={deleteNotificationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default AdminMappingCountry